import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import AllTranslations from "./components/AllTranslations";

import AccessDenied from "components/AccessDenied";
import PageContainer from "components/PageContainer";
import { useAuth } from "contexts/auth.context";
import Footer from "examples/Footer";
import { Route, Routes } from "react-router-dom";

function Translations() {
  const { checkPermission } = useAuth();

  /*if (
    Object.keys(checkPermission("summaryGroup")).filter(
      (key) => checkPermission("subscription")[key]
    ).length === 0
  ) {
    return <AccessDenied type="page" />;
  }*/

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <PageContainer>
        <Routes>
          <Route
            index
            element={
              <AllTranslations permissions={checkPermission("translation")} />
            }
          />
        </Routes>
      </PageContainer>

      <Footer />
    </DashboardLayout>
  );
}

export default Translations;
